import { AppEntity } from "@jackfruit/common"
import { select } from "@redux-saga/core/effects"
import { SagaIterator } from "@redux-saga/types"
import { DocumentApi } from "~/services/DocumentApi"
import { RootState } from "../store"

export function* getDocumentApi(): SagaIterator<DocumentApi> {
  const app: AppEntity = yield select((state: RootState) => state.application)

  if (!app.documentApiUrl) {
    const errorMessage = "Document API URL is not set in the application state"
    console.error(errorMessage)
    throw new Error(errorMessage)
  }

  const api = new DocumentApi(app.documentApiUrl)

  return api
}
